export default function algoliaFiltersFromUiState(indexUiState) {
	const query = indexUiState.query || "";
	const sortBy = indexUiState.sortBy || "";

	const refinements = Object.entries(indexUiState.refinementList || {}).map(([key, value]) => {
		if (value?.length > 1) {
			return value
				.map((value) => {
					return `${key}:"${value}"`;
				})
				?.join(" OR ");
		}
		return `${key}:"${value}"`;
	});

	const ranges = Object.entries(indexUiState.range || {}).map(([key, value]) => {
		const [from, to] = value.split(":");

		if (from && to) {
			return `${key}:${from} TO ${to}`;
		}

		if (from) {
			return `${key}>=${from}`;
		}

		if (to) {
			return `${key}<=${to}`;
		}

		return null;
	});

	const filters = [indexUiState.configure?.filters, ...refinements, ...ranges].filter(Boolean).join(" AND ");

	return { query, filters, sortBy };
}
